import { useContext } from 'react';
import { StudyCreateContext } from './StudyCreateProvider.tsx';

export const useStudyCreateStep = () => {
  const { currentStep, stepReady, setStepReady } = useContext(StudyCreateContext);
  return { currentStep, stepReady, setStepReady };
};

export const useStudyCreateGroups = () => {
  const { groups, treatments, groupsTreatments, plannedAnimalData, setPlannedAnimalData, updateStudyGroups } =
    useContext(StudyCreateContext);
  return { groups, treatments, groupsTreatments, plannedAnimalData, setPlannedAnimalData, updateStudyGroups };
};

export const useStudyCreateSave = () => {
  const { savingDraft, setSavingDraft, advancingStep, saveAndAdvance, loadDraftData, draftId, setDraftId } =
    useContext(StudyCreateContext);
  return { savingDraft, setSavingDraft, advancingStep, saveAndAdvance, loadDraftData, draftId, setDraftId };
};

export const useStudyCreateNavigation = () => {
  const { changeStep } = useContext(StudyCreateContext);
  return { changeStep };
};
